import { useDispatch } from "react-redux";
import { requestOTP } from "src/services/apiService";
import { useParams } from "react-router-dom";
import { useAppSelector } from "src/hooks/redux-hooks";
import { InfoCardWithAction } from "@simplecitizen/gdl-react-ui-components";

export interface LandingPageProps {
  scrollToNextPage?: any;
}

export const LandingPage = ({ scrollToNextPage }: LandingPageProps) => {
  const dispatch = useDispatch();
  const { checkId } = useParams<{ checkId: string }>();

  const handleClick = () => {
    scrollToNextPage();
    requestOTP(checkId, "check", dispatch);
  };


  const client = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.client
  );
  const message = useAppSelector(
    (state: any) => state?.questionnaire_data?.questionnaire?.message ?? ""
  );

  return (
    <div className="h-full  md:min-h-[70vh] overflow-auto md:pt-2 pt-4">
      <h1 className="sr-only">Right to Work Check</h1>
      <InfoCardWithAction
        onButtonClick={handleClick}
        content={message || (
          "WorkRight has been contracted by your employer to perform a Right to Work check to ensure " +
          "compliance with local laws. This process should only take a few minutes to complete. If you " +
          "do not have all the documents you need right now, you can click on the same link again later to continue. "
        )}
        buttonText="Begin right to work check"
        buttonColor={client?.branding?.primaryColor}
      />
    </div>
  );
};
